export const productNameWords = 'Everfox CDR Cloud API'
export const productNamePluralWords = 'Everfox CDR Cloud APIs'
export const productNameAsyncApiWords = 'Everfox CDR Cloud Async API'
export const productNameInstantApiWords = 'Everfox CDR Cloud Instant API'
export const productNameS3ApiWords = 'Everfox CDR Cloud S3 API'